import {Lightbox} from '../../classes/Lightbox';

const COMPONENT_SELECTOR = 'section.cds2-employees';

const CARD_EMPLOYEE_VISIBLE_CLASS = 'popup-visible';

const CARD_EMPLOYEE_CLASS = 'employee-card';

const CARD_EMPLOYEE_SELECTOR = `li.${CARD_EMPLOYEE_CLASS}`;

const EMPLOYEES_LIGHTBOX_CLASS = 'employees';

const BREAKPOINT = 1024;

const initEmployees = () => {
	let isComponentExist = false;
	
	document.querySelectorAll( COMPONENT_SELECTOR )
		.forEach( ( component ) => {
			isComponentExist = true;
			
			component.addEventListener( 'click', ( evt ) => {
				const card = evt.target.closest( `${CARD_EMPLOYEE_SELECTOR}:not(.empty-popup)` );
				
				if ( card && window.innerWidth < BREAKPOINT )
				{
					const markup = card.querySelector( 'div.popup > div.info' ).outerHTML;
					
					Lightbox.open( markup, null, 'tooltip', EMPLOYEES_LIGHTBOX_CLASS );
					
					const lightbox = Lightbox.getLightbox();
					
					if ( lightbox )
					{
						const content = lightbox.querySelector( 'div.wrapper > div.content' );
						const info = lightbox.querySelector( 'div.wrapper > div.content > div.info' );
						
						if ( content && info )
						{
							if ( content.offsetHeight < info.offsetHeight )
							{
								content.addEventListener(
									'touchmove',
									( evt ) => {
										evt.stopImmediatePropagation();
									},
									true
								)
							}
						}
					}
				}
			} );
			
			const cards = Array.from( component.querySelectorAll( `ul > ${CARD_EMPLOYEE_SELECTOR}` ) );
			
			cards.forEach( ( card ) => {
				card.addEventListener(
					'mouseenter',
					( evt ) => {
						if ( evt.target === card )
						{
							cards.filter( ( item ) => item !== card && item.classList.contains( CARD_EMPLOYEE_VISIBLE_CLASS ) )
								.forEach( ( item ) => item.classList.remove( CARD_EMPLOYEE_VISIBLE_CLASS ) );
							
							card.style.minHeight = `${card.offsetHeight}px`;
							card.classList.add( CARD_EMPLOYEE_VISIBLE_CLASS );
						}
					},
					true
				);
				
				card.addEventListener(
					'mouseleave',
					( evt ) => {
						if ( evt.target === card )
						{
							card.classList.remove( CARD_EMPLOYEE_VISIBLE_CLASS );
							card.style.removeProperty('min-height')
						}
					},
					true
				);
			} );
		} );
	
	if ( isComponentExist )
	{
		window.addEventListener( 'resize', () => {
			const lightbox = Lightbox.getLightbox();
			
			if (
				lightbox
				&& lightbox.classList.contains( EMPLOYEES_LIGHTBOX_CLASS )
				&& window.innerWidth >= BREAKPOINT
			)
			{
				Lightbox.close();
			}
		} );
	}
};

export {
	initEmployees,
};
